const base = 'https://api-staging.smallpay.it';

export const environment = {
  production: true,
  base,
  baseUrl: `${base}/market-api`,
  basePublic: `${base}/market-public`,
  baseTrx: `https://api-staging.smallpay.it/trx-api`,
  nexiUrl: 'https://int-ecommerce.nexi.it',
  nexiAlternativeUrl: 'https://int-ecommerce.nexi.it/ecomm/ecomm/DispatcherServlet',
  stripePublicKey: 'pk_test_51JbmowL6TUZoXRJAz1pNzEL9uN1pScmHH70yUyrQ0cRrbYWtH2l0GbcFhMnUFwarua8iZSRWMOxwP4RJtVWxAtCU00JKlzwu5Y',
  context: 'staging',
  markerResourceUrl: 'https://sp-staging-resources.s3.eu-south-1.amazonaws.com',
  marketDomain: 'market-staging.smallpay.it'
};
